import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { courseTypes, activityTypes } from "../../constants";
import { useTranslation } from "react-i18next";

export default function CourseCardOverline(props) {
  const { courseType } = props;
  const { t } = useTranslation();
  function getOverlineText() {
    switch (courseType.toLowerCase()) {
      case courseTypes.webinar.toLowerCase():
        return t("courseCard.courseType.webinar");
      case courseTypes.ilt.toLowerCase():
      case courseTypes.instructorLedTraining.toLowerCase():
        return t("courseCard.courseType.inPerson");
      case courseTypes.virtual.toLowerCase():
        return t("courseCard.courseType.virtualClassroom");
      case activityTypes.video.toLowerCase():
      case courseTypes.online.toLowerCase():
      case courseTypes.onlineCourse.toLowerCase():
        return t("courseCard.courseType.onlineCourse");
      case courseTypes.policy.toLowerCase():
        return t("courseCard.courseType.policy");
      default:
        return "";
    }
  }
  return courseType ? (
    <Box mt={-0.5}>
      <Typography variant="overline" color="textSecondary">
        {getOverlineText()}
      </Typography>
    </Box>
  ) : null;
}

CourseCardOverline.propTypes = {
  courseType: PropTypes.string.isRequired
};
